import { Component, Input } from '@angular/core';
import { OrderPreviewData } from '../../order-preview.component';
import { CourierRepo } from 'src/app/core/repositories/courier.repo';
import { PhotoType } from './models/photo';
import { ToastPosition, ToastService } from 'src/app/core/services/toast.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { CameraService } from 'src/app/core/services/camera.service';

@Component({
  selector: 'app-order-photos',
  templateUrl: './order-photos.component.html',
  styleUrls: ['./order-photos.component.scss'],
})
export class OrderPhotosComponent {
  @Input({ required: true }) data!: OrderPreviewData;
  safeImageUrl?: string;
  blob?: Blob;

  constructor(
    private courierRepo: CourierRepo,
    private toastService: ToastService,
    private cameraService: CameraService,
  ) { }

  async takePhoto(): Promise<void> {
    const cameraResult = await this.cameraService.takePhoto();
    this.safeImageUrl = cameraResult?.sanitizedUrl;
    this.blob = cameraResult?.blob;
  }

  async uploadPhoto(): Promise<void> {
    this.courierRepo.uploadPhoto(this.data.order.id, this.blob!, PhotoType.Permanent)
      .pipe(catchError(() => {
        this.showErrorToast();
        return EMPTY;
      }))
      .subscribe(() => this.showSuccessToast());
  };

  clearImage($event: Event): void {
    $event.preventDefault();
    this.safeImageUrl = undefined;
    this.blob = undefined;
  }

  private showSuccessToast(): void {
    this.toastService.showSuccessToast("Afbeelding is succesvol opgeslagen", ToastPosition.Top, 2000);
  }

  private showErrorToast(): void {
    this.toastService.showErrorToast("Opslaan is mislukt, probeer later opnieuw", ToastPosition.Top, 2000);
  }
}

